import "./Footer.css";
const Footer = () => {
  return (
    <div className="footer">
      <p>Jani Myllymaa project @2023</p>
    </div>
  );
};

export default Footer;
